export default "dist/images/higher-order-with-design-layout-selector-basic.ebc668b.png";